<!--Instructions-->
<div>
	<label
		>Do you want to stop this email from receiving notifcations for just this facility ({{ FacilityName }}) or for the whole district (so they won't receive
		any emails)</label
	>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onFacility()">Just this Facility</button>
	<button class="btn btn-danger" style="margin-left: 5px" (click)="onDistrict()">District (No more emails)</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
